<template>
  <div class="au-brand" :class="variant === 'hero' ? 'au-brand--hero' : 'au-brand--compact'">
    <h1 class="au-wordmark">{{ STRINGS.branding.title }}</h1>

    <template v-if="variant === 'hero'">
      <p class="au-tagline">{{ STRINGS.branding.tagline }}</p>
      <FaceoffMotif />
    </template>

    <template v-else>
      <span class="au-hairline" aria-hidden="true"></span>
      <h2 v-if="title" class="au-title">{{ title }}</h2>
    </template>
  </div>
</template>

<script setup lang="ts">
import STRINGS from '@/constants/strings';
import FaceoffMotif from './FaceoffMotif.vue';

defineProps<{
  variant: 'hero' | 'compact';
  title?: string;
}>();
</script>
